import { Backdrop, CircularProgress } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import beepSound from "../../assets/audio/live-class-beep.wav";

const LiveClassLoader = ({ open = true, showLoader }) => {
  const audioRef = useRef(null);

  useEffect(() => {
    const playAudio = async () => {
      try {
        await audioRef?.current?.play();
      } catch (err) {
        console.error("Autoplay failed:", err);
      }
    };
    playAudio();
  }, []);

  return (
    <>
      {showLoader ? (
        <>
          <audio ref={audioRef} src={beepSound} />
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={open}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default LiveClassLoader;
